export const appId = 'org.openedx.frontend.app.authn';
